/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateClientInsightBody,
  GetClientInsightsParams,
  InsightDto,
  InsightUpdateRequest,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getClientInsightById = (
  userId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightDto>(
    {
      url: `/api/${userId}/clients/${clientId}/insights/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetClientInsightByIdQueryKey = (
  userId: string,
  clientId: number,
  id: number
) => {
  return [`/api/${userId}/clients/${clientId}/insights/${id}`] as const;
};

export const getGetClientInsightByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientInsightById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsightById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientInsightByIdQueryKey(userId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientInsightById>>
  > = ({ signal }) =>
    getClientInsightById(userId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientInsightById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientInsightByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientInsightById>>
>;
export type GetClientInsightByIdQueryError = ErrorType<unknown>;

export function useGetClientInsightById<
  TData = Awaited<ReturnType<typeof getClientInsightById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsightById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientInsightById>>,
          TError,
          Awaited<ReturnType<typeof getClientInsightById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientInsightById<
  TData = Awaited<ReturnType<typeof getClientInsightById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsightById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientInsightById>>,
          TError,
          Awaited<ReturnType<typeof getClientInsightById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientInsightById<
  TData = Awaited<ReturnType<typeof getClientInsightById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsightById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientInsightById<
  TData = Awaited<ReturnType<typeof getClientInsightById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsightById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientInsightByIdQueryOptions(
    userId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateClientInsight = (
  userId: string,
  clientId: number,
  id: number,
  insightUpdateRequest: BodyType<InsightUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightDto>(
    {
      url: `/api/${userId}/clients/${clientId}/insights/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: insightUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateClientInsightMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientInsight>>,
    TError,
    {
      userId: string;
      clientId: number;
      id: number;
      data: BodyType<InsightUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientInsight>>,
  TError,
  {
    userId: string;
    clientId: number;
    id: number;
    data: BodyType<InsightUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateClientInsight'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientInsight>>,
    {
      userId: string;
      clientId: number;
      id: number;
      data: BodyType<InsightUpdateRequest>;
    }
  > = (props) => {
    const { userId, clientId, id, data } = props ?? {};

    return updateClientInsight(userId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientInsightMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientInsight>>
>;
export type UpdateClientInsightMutationBody = BodyType<InsightUpdateRequest>;
export type UpdateClientInsightMutationError = ErrorType<unknown>;

export const useUpdateClientInsight = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClientInsight>>,
      TError,
      {
        userId: string;
        clientId: number;
        id: number;
        data: BodyType<InsightUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateClientInsight>>,
  TError,
  {
    userId: string;
    clientId: number;
    id: number;
    data: BodyType<InsightUpdateRequest>;
  },
  TContext
> => {
  return useMutation(
    getUpdateClientInsightMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL, ROLE_REPORT_ADMIN**<br /><br />
 */
export const deleteClientInsight = (
  userId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/clients/${clientId}/insights/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteClientInsightMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientInsight>>,
    TError,
    { userId: string; clientId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientInsight>>,
  TError,
  { userId: string; clientId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteClientInsight'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientInsight>>,
    { userId: string; clientId: number; id: number }
  > = (props) => {
    const { userId, clientId, id } = props ?? {};

    return deleteClientInsight(userId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientInsightMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientInsight>>
>;

export type DeleteClientInsightMutationError = ErrorType<unknown>;

export const useDeleteClientInsight = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClientInsight>>,
      TError,
      { userId: string; clientId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientInsight>>,
  TError,
  { userId: string; clientId: number; id: number },
  TContext
> => {
  return useMutation(
    getDeleteClientInsightMutationOptions(options),
    queryClient
  );
};
/**
 * In bulk GET requests, the imageUrl field is not populated.
To retrieve the image URL, use the GET by id endpoint instead
</br></br>Authorities: **Any authenticated role**
 */
export const getClientInsights = (
  userId: string,
  clientId: number,
  params?: GetClientInsightsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/insights`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientInsightsQueryKey = (
  userId: string,
  clientId: number,
  params?: GetClientInsightsParams
) => {
  return [
    `/api/${userId}/clients/${clientId}/insights`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientInsightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientInsights>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsights>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientInsightsQueryKey(userId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientInsights>>
  > = ({ signal }) =>
    getClientInsights(userId, clientId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientInsights>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientInsightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientInsights>>
>;
export type GetClientInsightsQueryError = ErrorType<unknown>;

export function useGetClientInsights<
  TData = Awaited<ReturnType<typeof getClientInsights>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: undefined | GetClientInsightsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsights>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientInsights>>,
          TError,
          Awaited<ReturnType<typeof getClientInsights>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientInsights<
  TData = Awaited<ReturnType<typeof getClientInsights>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsights>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientInsights>>,
          TError,
          Awaited<ReturnType<typeof getClientInsights>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientInsights<
  TData = Awaited<ReturnType<typeof getClientInsights>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsights>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientInsights<
  TData = Awaited<ReturnType<typeof getClientInsights>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetClientInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientInsights>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientInsightsQueryOptions(
    userId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL, ROLE_REPORT_ADMIN**<br /><br />
 */
export const createClientInsight = (
  userId: string,
  clientId: number,
  createClientInsightBody: BodyType<CreateClientInsightBody>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `insightRequest`,
    JSON.stringify(createClientInsightBody.insightRequest)
  );
  formData.append(`file`, createClientInsightBody.file);

  return customAxios<InsightDto>(
    {
      url: `/api/${userId}/clients/${clientId}/insights`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getCreateClientInsightMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientInsight>>,
    TError,
    {
      userId: string;
      clientId: number;
      data: BodyType<CreateClientInsightBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientInsight>>,
  TError,
  { userId: string; clientId: number; data: BodyType<CreateClientInsightBody> },
  TContext
> => {
  const mutationKey = ['createClientInsight'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientInsight>>,
    {
      userId: string;
      clientId: number;
      data: BodyType<CreateClientInsightBody>;
    }
  > = (props) => {
    const { userId, clientId, data } = props ?? {};

    return createClientInsight(userId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientInsightMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientInsight>>
>;
export type CreateClientInsightMutationBody = BodyType<CreateClientInsightBody>;
export type CreateClientInsightMutationError = ErrorType<unknown>;

export const useCreateClientInsight = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClientInsight>>,
      TError,
      {
        userId: string;
        clientId: number;
        data: BodyType<CreateClientInsightBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createClientInsight>>,
  TError,
  { userId: string; clientId: number; data: BodyType<CreateClientInsightBody> },
  TContext
> => {
  return useMutation(
    getCreateClientInsightMutationOptions(options),
    queryClient
  );
};
